<span class="odds" [ngClass]="{ 'is-boosted': isBoosted }" [@oldOddsAnimation]="isBoosted ? formattedOdds : null" [@.disabled]="!withAnimation">{{
    formattedOdds
}}</span>

@if (isBoosted) {
    <span class="boosted-odds" [@newOddsAnimation]="formattedBoostedOdds" [@.disabled]="!withAnimation">{{ formattedBoostedOdds }}</span>
}
